// reducers/systems/execute.js

export function executeHasErrored(state = false, action) {
  switch (action.type) {
    case 'EXECUTE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function executeIsLoading(state = false, action) {
  switch (action.type) {
    case 'EXECUTE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function execute(state = [], action) {
  switch (action.type) {
    case 'EXECUTE_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}